import { render, staticRenderFns } from "./WFieldset.vue?vue&type=template&id=93fa8276&scoped=true&"
import script from "./WFieldset.vue?vue&type=script&lang=js&"
export * from "./WFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa8276",
  null
  
)

export default component.exports